import {Component, ViewChild} from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { SuperTabsComponent } from '../../components/ionic2-super-tabs/src/components/super-tabs';

import {UnitOverviewPage} from "../unit-overview/unit-overview";
import {UnitReportsPage} from "../unit-reports/unit-reports";
import {UnitInfoPage} from "../unit-info/unit-info";
import {UnitHistoryPage} from "../unit-history/unit-history";

@Component({
  selector: 'page-unit',
  templateUrl: 'unit.html',
})
export class UnitPage {

  @ViewChild('unitTabs') superTabs: SuperTabsComponent;

  unitOverviewPage = UnitOverviewPage;
  unitInfoPage = UnitInfoPage;
  unitHistoryPage = UnitHistoryPage;
  unitReportsPage = UnitReportsPage;

  unit: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.unit = this.navParams.get('unit');
    console.log(this.unit);
  }

  onTabSelect(tab: { index: number; id: string; }) {
    console.log(`Selected tab: `, tab);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UnitPage');
  }

  public openReport(report){
    if(report.files && report.files.length){
      window.open(report.files[0].download_url);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/unit/unit.ts